import { render, staticRenderFns } from "./handlingRow.vue?vue&type=template&id=37c7ed31"
import script from "./handlingRow.vue?vue&type=script&lang=ts"
export * from "./handlingRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports